<template>
  <div class="recommend-card" @click="$emit('click', course)">
    <div class="card-thumb">
      <img :src="course.img" alt="cover" />
      <div v-if="course.cat === '课程' && course.isDiscount" class="thumb-badge-top">惠</div>
      <div v-else-if="course.cat === '课程' && course.badges && course.badges.includes('热门')" class="thumb-badge-top new">新</div>
      <div v-else-if="course.badges && course.badges.length" class="hot-badge">{{ course.badges[0] }}</div>
      <div v-if="course.cat === '课程' && course.desc" class="thumb-subtitle">{{ course.desc }}</div>
    </div>
    <div class="card-content">
      <div class="card-title">{{ course.title }}</div>
      <div class="card-tags">
        <span v-if="course.categoryName && course.cat !== '图书' && course.cat !== '学习机'" class="tag-blue">{{ course.categoryName }}</span>
        <span v-if="course.lessonCount > 0" class="tag-gray">共{{ course.lessonCount }}节</span>
      </div>
      <div v-if="course.isDiscount && course.discountEndTime" class="card-countdown">
        <span class="countdown-label">限时折扣：</span>
        <span class="countdown-time">{{ getCountdownText(course.discountEndTime) }}</span>
      </div>
      <div class="card-sales-row">
        <span class="card-sales">{{ course.sales || 0 }}{{ course.cat === '图书' ? '人已购买' : '人已学' }}</span>
      </div>
      <div class="card-dashed"></div>
      <div class="card-price-row">
        <span class="price-current">
          ¥<span class="price-int">{{ priceParts(course.price).int }}</span>
          <span class="price-dec">.{{ priceParts(course.price).dec }}</span>
        </span>
        <span v-if="Number(course.salePrice) > Number(course.price)" class="price-old">
          原价：¥{{ formatPrice(course.salePrice) }}
        </span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'RecommendCard',
  props: {
    course: { type: Object, required: true }
  },
  emits: ['click'],
  methods: {
    priceParts(p) {
      const n = Number(p || 0)
      const s = n.toFixed(2)
      const [int, dec] = s.split('.')
      return { int, dec }
    },
    formatPrice(p) {
      return Number(p || 0).toFixed(2)
    },
    getCountdownText(endTime) {
      if (!endTime) return ''
      const end = new Date(endTime).getTime()
      const now = Date.now()
      const diff = end - now
      if (diff <= 0) return '已结束'
      const hours = Math.floor(diff / 3600000)
      const mins = Math.floor((diff % 3600000) / 60000)
      const secs = Math.floor((diff % 60000) / 1000)
      if (hours > 0) return `${hours}时${mins}分${secs}秒`
      return `${mins}分${secs}秒`
    }
  }
}
</script>

<style scoped lang="scss">
.recommend-card {
  border-radius: 8px;
  overflow: hidden;
  background: #fff;
  border: 1px solid #f0f0f0;
  display: flex;
  flex-direction: column;
  cursor: pointer;
  transition: all 0.3s;

  &:hover {
    transform: translateY(-5px);
    box-shadow: 0 10px 20px rgba(0,0,0,0.08);
  }
}

.card-thumb {
  width: 100%;
  height: 171px;
  position: relative;
  overflow: hidden;
  background: #f5f5f5;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }

  .thumb-badge-top {
    position: absolute;
    top: 0;
    left: 0;
    width: 48px;
    height: 48px;
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
    background: #FF4D4F;
    color: #fff;
    font-size: 14px;
    font-weight: 600;
    padding: 4px 0 0 8px;
    clip-path: polygon(0 0, 100% 0, 0 100%);
    z-index: 3;

    &.new {
      background: #3E2CCD;
    }
  }

  .thumb-subtitle {
    position: absolute;
    left: 0;
    right: 0;
    bottom: 0;
    background: linear-gradient(90deg, #FFB100, #FFD15C);
    color: #5B3A02;
    font-size: 12px;
    font-weight: 600;
    padding: 5px 10px;
    text-align: center;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    z-index: 2;
  }

  .hot-badge {
    position: absolute;
    top: 0;
    left: 0;
    background: #E03A31;
    color: #fff;
    font-size: 12px;
    padding: 2px 6px;
    border-bottom-right-radius: 8px;
  }
}

.card-content {
  padding: 16px;
  flex: 1;
  display: flex;
  flex-direction: column;

  .card-title {
    font-size: 16px;
    font-weight: bold;
    color: #333;
    line-height: 1.4;
    margin-bottom: 8px;
    height: 44px;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
  }

  .card-tags {
    display: flex;
    align-items: center;
    gap: 8px;
    margin-bottom: 8px;
    min-height: 22px;

    .tag-blue {
      background: #F1F0F0;
      color: #1890FF;
      font-size: 12px;
      padding: 2px 10px;
      border-radius: 12px;
      border: 1px solid #CBD4FA;
    }

    .tag-gray {
      color: #909399;
      font-size: 12px;
    }
  }

  .card-countdown {
    font-size: 12px;
    margin-bottom: 8px;

    .countdown-label { color: #909399; }
    .countdown-time { color: #FF4D4F; font-weight: 600; }
  }

  .card-sales-row {
    margin-bottom: 8px;

    .card-sales {
      color: #909399;
      font-size: 12px;
    }
  }

  .card-dashed {
    border-top: 1px dashed #ebeef5;
    margin: 4px 0 12px;
  }

  .card-price-row {
    display: flex;
    align-items: baseline;
    gap: 8px;
    margin-top: auto;

    .price-current {
      color: #FF4D4F;
      font-size: 12px;
      font-weight: 700;

      .price-int { font-size: 18px; }
      .price-dec { font-size: 12px; }
    }

    .price-old {
      color: #909399;
      font-size: 12px;
      text-decoration: line-through;
    }
  }
}
</style>
